// Typelizer digest 0309eff797f46e5dc8f158d0d875f7e0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /profile */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/profile', {}, options),
    method: 'patch',
  }),
}
